import styled from 'styled-components';

import React from 'react';

import { Popover, Tooltip } from 'antd';
import { Icon } from 'components/common';
import { colours } from 'utils/theme';

const CrmSection = styled.div`
  padding-top: 10px;
`;

const ClickableIcon = styled(Icon)`
  cursor: pointer;
`;

const CrmPushDetailsContent = ({ crmPushDetail }) => {
  if (crmPushDetail.crmError) {
    return (
      <CrmSection>
        <b>{crmPushDetail.crmType}</b>
        <pre>{crmPushDetail.crmError}</pre>
        Please search this error code with your CRM provider.
      </CrmSection>
    );
  } else {
    return (
      <CrmSection>
        <a href={crmPushDetail.crmMemberUrl} target='_blank' rel='noreferrer'>
          <b>Open in {crmPushDetail.crmType}</b>
        </a>
      </CrmSection>
    );
  }
};

const CRMStatus = ({ crmPushDetails }) => {
  if (!crmPushDetails || crmPushDetails.length === 0) return null;

  const openLink = url => window.open(url, '_blank');

  const CRM = ({ crmPushDetail }) => {
    if (crmPushDetail.crmMemberUrl) {
      return (
        <Tooltip title={crmPushDetail.crmType}>
          <div style={{ display: 'flex', alignItems: 'center' }}>
            <ClickableIcon
              icon={crmPushDetail.crmType.toLowerCase()}
              size='lg'
              color={colours.brands[crmPushDetail.crmType.toLowerCase()]}
              onClick={() => openLink(crmPushDetail.crmMemberUrl)}
            />
          </div>
        </Tooltip>
      );
    }

    return (
      <Popover
        placement='left'
        trigger='click'
        content={<CrmPushDetailsContent crmPushDetail={crmPushDetail} />}
      >
        <Tooltip title={`${crmPushDetail.crmType} push failed`}>
          <div
            style={{ display: 'flex', alignItems: 'center', cursor: 'pointer' }}
          >
            <Icon
              icon={crmPushDetail.crmType.toLowerCase()}
              size='lg'
              color='red'
            />
          </div>
        </Tooltip>
      </Popover>
    );
  };

  return crmPushDetails.map(x => <CRM key={x.crmType} crmPushDetail={x} />);
};

export default CRMStatus;
